'use client';

import { DocsShell } from '@bomdisoft/components/docs';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';
import { buildConsoleDocuments } from 'Clepit/shared/docs-content';
import { docsNav } from 'Clepit/shared/docs-nav-manifest';
import { docsThemeOverrides } from 'Clepit/shared/docs-theme';

const ConsoleDocumentsPage = () => {
  const params = useParams();
  const langPrefix = typeof params.lang === 'string' ? params.lang : 'en';
  const language = getLanguageFromLocale(langPrefix);
  return <DocsShell content={buildConsoleDocuments(language)} lang={language} langPrefix={langPrefix} nav={docsNav} testId='docs-shell' themeOverrides={docsThemeOverrides} />;
};

export default ConsoleDocumentsPage;
